import {
  IAutoAssessmentFilterOptions,
  IAutoAssessmentsFilterData,
} from '../types';

/**
 * Formats the filters API response for auto assessments.
 */
export function formatAutoAssessmentsFilters(
  response: IAutoAssessmentFilterOptions[]
): IAutoAssessmentsFilterData {
  const filterList = response.map((item) => {
    // eslint-disable-next-line camelcase
    const { count, key, label, label_ar } = item;

    return {
      count,
      key,
      label: {
        en: label,
        // eslint-disable-next-line camelcase
        ar: label_ar || label,
      },
    };
  });

  return {
    filterOptions: filterList,
  };
}
